import React from "react";

export const FormActionsContainer = ({ record }) => {
  return <div></div>;
};

export default FormActionsContainer;
